<template>
  <v-card>
    <v-card-title>
      Options
      <v-spacer />
    </v-card-title>
    <v-divider />
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      disable-pagination
      hide-default-footer
      show-expand
      mobile-breakpoint="0"
      group-by="group.id"
    >
      <template #[`group.header`]="{ items, isOpen, toggle }">
        <th colspan="100%">
          <v-icon @click="toggle">
            {{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
          </v-icon>
          {{ items[0].group.name }}
        </th>
      </template>

      <template #[`item.providerId`]="{ item }">
        {{ provider_name(item.providerId) }}
      </template>
      <template #[`item.displayName`]="{ item }">
        <v-text-field
          v-model="item.displayName"
          outlined
          dense
          hide-details="auto"
          @blur="save('displayName', item)"
        >
        </v-text-field>
      </template>
      <template #[`item.sortOrder`]="{ item }">
        <v-text-field
          v-model="item.sortOrder"
          outlined
          dense
          hide-details="auto"
          type="number"
          @blur="save('sortOrder', item)"
        >
        </v-text-field>
      </template>
      <template #[`item.description`]="{ item }">
        <v-icon :color="item.description ? 'success' : 'error'">
          {{ item.description ? 'check_circle' : 'cancel' }}
        </v-icon>
      </template>
      <template #[`item.hex`]="{ item }">
        <v-text-field
          v-model="item.hex"
          outlined
          dense
          hide-details="auto"
          @blur="save('hex', item)"
        >
        </v-text-field>
      </template>
      <template #[`item.imageUrl`]="{ item }">
        <v-img
          v-if="item.imageUrl"
          :src="item.imageUrl"
          height="100"
          :max-width="100"
          contain
          @click="showUpload(item)"
        />
        <v-btn
          v-else
          @click="showUpload(item)"
        >
          Upload
        </v-btn>
      </template>

      <template #expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-textarea
            v-model="item.description"
            outlined
            label="Description"
            dense
            class="my-2 white"
            hide-details="auto"
            @blur="save('description', item)"
          >
          </v-textarea>
        </td>
      </template>
    </v-data-table>
    <LoadingSpinnerDialog :loading="loading_dialog" />
    <AddOptionImage />
  </v-card>
</template>

<script>
import AddOptionImage from '@/components/print/AddOptionImage';
import { sortBy } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  name: 'PrintOptions',
  components: { AddOptionImage },
  props: {},
  data: () => ({
    loading: true,
    loading_dialog: false,
    groupId: null,
    type: 'options',
    headers: [
      {
        text: 'Group',
        value: 'group.id'
      },
      { text: 'Name', value: 'name' },
      { text: 'Display Name', value: 'displayName' },
      { text: 'Desc', value: 'description' },
      { text: 'Hex', value: 'hex' },
      { text: 'Provider', value: 'providerId' },
      { text: 'Order', value: 'sortOrder' },
      { text: 'Image', value: 'imageUrl' }
    ]
  }),
  computed: {
    items() {
      const items = this.lookups.options;
      if (!items) {
        return [];
      }

      return sortBy(items, 'group.name', 'sortOrder');
    },
    ...mapGetters({
      provider_name: 'lookup/print_provider_name',
      lookups: 'print/lookups'
    })
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch('print/getLookups')
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save(field, item) {
      this.loading = true;
      this.$store
        .dispatch('print/override', {
          type: this.type,
          field: field,
          id: item.id,
          value: item[field]
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showUpload(item) {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.ADD_PRINT_OPTION_IMAGE_SHOW, { option: item });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-input__append-outer {
  margin-top: 0 !important;
}
</style>
